import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import SoftTypography from "components/SoftTypography";
import SoftAvatar from "components/SoftAvatar";
import { useEffect, useState } from "react";
import { baseURL } from "utils/api";
import curved0 from "assets/images/curved-images/curved0.jpg";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import Card from "@mui/material/Card";
import SoftInput from "components/SoftInput";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import IconButton from "@mui/material/IconButton";
import {
  useSoftUIController,
  setTransparentSidenav,
  setSidenavColor,
} from "context";
import toast from "react-hot-toast";
import { Switch } from "@mui/material";
import { ChangeThemeOnRedux } from "api/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { ArrowCircleRightOutlined } from "@mui/icons-material";

function Overview() {
  const userTheme = useSelector((state) => state.commonSlice.theme);
  const dispatcho = useDispatch();
  const [data, setData] = useState({});
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [controller, dispatch] = useSoftUIController();
  const { transparentSidenav, sidenavColor } = controller;
  const [disabled, setDisabled] = useState(false);
  const sidenavColors = [
    "primary",
    "dark",
    "info",
    "success",
    "warning",
    "error",
  ];
  const [profileImage, setProfileImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [theme, setTheme] = useState(userTheme);
  // Use the useEffect hook to change the button state for the sidenav type based on window size.

  useEffect(() => {
    function handleDisabled() {
      return window.innerWidth > 1200 ? setDisabled(false) : setDisabled(true);
    }
    window.addEventListener("resize", handleDisabled);
    handleDisabled();
    return () => window.removeEventListener("resize", handleDisabled);
  }, []);

  const handleTransparentSidenav = () => setTransparentSidenav(dispatch, true);
  const handleWhiteSidenav = () => setTransparentSidenav(dispatch, false);
  const sidenavTypeButtonsStyles = ({
    functions: { pxToRem },
    boxShadows: { buttonBoxShadow },
  }) => ({
    height: pxToRem(42),
    boxShadow: buttonBoxShadow.main,

    "&:hover, &:focus": {
      opacity: 1,
    },
  });

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("id");
    window.location.href = "/login";
  };

  useEffect(() => {
    setLoading(true);
    fetch(`${baseURL}userProfile/${localStorage.getItem("id")}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data, "user profile");
        setLoading(false);
        if (data?.success) {
          setProfileImage(data?.data?.profileImage);
          setData(data?.data);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);

  const handleConfirm = () => {
    if (password !== confirmPassword) {
      return toast.error("passwords do not match");
    }
    fetch(`${baseURL}updatePassword`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({ newPassword: password, oldPassword: oldPassword, role:"BUSINESS" }),
    })
      .then((res) => res.json())
      .then((resp) => {
        if (resp.success) {
          toast.success("password changed successfully");
          // navigate("/home");
          setPassword("");
          setOldPassword("");
          setConfirmPassword("");
        } else {
          return toast.error(resp.message);
        }
      });
  };

  const ChangeToLightMode = () => {
    const theme = localStorage.getItem("theme");
    // Update the theme in localStorage and apply styles
    if (theme === "dark") {
      setTheme("light");
      dispatcho(ChangeThemeOnRedux("light"));
      localStorage.setItem("theme", "light");
      document.body.classList.add("light-mode");
      document.body.classList.remove("dark-mode");
    } else {
      setTheme("dark");
      dispatcho(ChangeThemeOnRedux("dark"));
      localStorage.setItem("theme", "dark");
      document.body.classList.add("dark-mode");
      document.body.classList.remove("light-mode");
    }
  };

  useEffect(() => {
    const storedTheme = localStorage.getItem("theme") || "light";
    setTheme(storedTheme);
    dispatcho(ChangeThemeOnRedux(storedTheme));
    document.body.classList.add(`${storedTheme}-mode`);
  }, []);

  return (
    <DashboardLayout>
      <SoftBox
        position="relative"
        borderRadius="xl"
        // mx={10}
        // mt={10}
      // sx={{
      //   backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
      //     `${linearGradient(
      //       rgba(gradients.info.main, 0.6),
      //       rgba(gradients.info.state, 0.6)
      //     )}, url(${curved0})`,
      //   backgroundSize: "cover",
      //   backgroundPosition: "50%",
      //   overflow: "hidden",
      // }}
      >
        <SoftBox>
          <SoftBox
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="100%"
          />

          <Card
            className="glassmorphism-card"
            sx={{
              backdropFilter: `saturate(200%) blur(30px)`,
              backgroundColor: ({ functions: { rgba }, palette: { white } }) =>
                rgba(white.main, 0.2),
              boxShadow: ({ boxShadows: { navbarBoxShadow } }) =>
                navbarBoxShadow,
              // position: "relative",
              // top: 125,
              // left: 120,
              // mt: -12,
              // mx: 3,
              py: 2,
              px: 2,
              // width: 830,
              borderRadius: "xl",
            }}
          >
            <ArrowCircleRightOutlined
              style={{
                transform: "rotate(180deg)",
                color: userTheme === "dark" ? "#ffffff" : "#141414",
                cursor: "pointer", // Ensures the icon looks clickable
              }}
              fontSize="large"
              onClick={() => window.history.back()} // Go back to the previous page
            />
            <SoftBox
              spacing={3}
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
            >
              {profileImage != "" ? (
                <SoftAvatar
                  src={profileImage}
                  alt="profile-image"
                  variant="rounded"
                  size="xxl"
                  shadow="sm"
                />
              ) : (
                ""
              )}
              <SoftBox height="100%" mt={2} lineHeight={1}>
                <SoftTypography variant="h3" fontWeight="medium">
                  {data?.firstName} {data?.lastName}
                </SoftTypography>
                {/* <SoftTypography variant="button" color="text" fontWeight="medium">
                  {data?.userType}
                </SoftTypography> */}
              </SoftBox>
            </SoftBox>
          </Card>
        </SoftBox>

        <SoftBox
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}

        // mt={3}
        >
          <SoftBox
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              // height: "75vh",
              width: "100%",
            }}
            gap={3}
            mt={3}
          >
            <Card
              className="glassmorphism-card"
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: 2,
                boxShadow: 2,
              }}
            >
              <SoftTypography component="label" variant="h6" fontWeight="bold">
                Change Password
              </SoftTypography>
              <SoftBox
                mb={1}
                sx={{
                  width: "100%",
                }}
              >
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Old Password
                </SoftTypography>
                <SoftInput
                  required
                  onChange={(e) => setOldPassword(e.target.value)}
                  type="password"
                  placeholder="Old Password"
                />
              </SoftBox>
              <SoftBox
                mb={1}
                sx={{
                  width: "100%",
                }}
              >
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Password
                </SoftTypography>
                <SoftInput
                  required
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  placeholder="New Password"
                />
              </SoftBox>
              <SoftBox
                mb={3}
                sx={{
                  width: "100%",
                }}
              >
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Confirm Password
                </SoftTypography>
                <SoftInput
                  required
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  type="password"
                  placeholder="Confirm New Password"
                />
              </SoftBox>
              <SoftButton
                variant="gradient"
                color="info"
                // fullWidth
                onClick={handleConfirm}
              >
                submit
              </SoftButton>
            </Card>
            {/* <Card className="glassmorphism-card">
              <SoftBox
                display="flex"
                flexDirection="column"
              >
                <SoftBox
                  display="flex"
                  justifyContent="space-between"

                  alignItems="baseline"
                  pt={3}
                  pb={0.8}
                  px={3}
                >
                  <SoftBox>
                    <SoftTypography variant="h5">Admin Configurator</SoftTypography>
                    <SoftTypography variant="caption" color="text">
                      See our dashboard options.
                    </SoftTypography>
                  </SoftBox>

                </SoftBox>

               
                <SoftBox px={3}>
                  <SoftTypography variant="h6">Light Theme</SoftTypography>
                  <Switch onChange={ChangeToLightMode} checked={theme == 'dark' ? false : true} />
                </SoftBox>



                <SoftBox pt={1} pb={1} px={3}>
                  <SoftBox>
                    <SoftTypography variant="h6">Sidenav Colors</SoftTypography>

                    <SoftBox mb={0.5}>
                      {sidenavColors.map((color) => (
                        <IconButton
                          key={color}
                          sx={({ borders: { borderWidth }, palette: { white, dark }, transitions }) => ({
                            width: "24px",
                            height: "24px",
                            padding: 0,
                            border: `${borderWidth[1]} solid ${white.main}`,
                            borderColor: sidenavColor === color && dark.main,
                            transition: transitions.create("border-color", {
                              easing: transitions.easing.sharp,
                              duration: transitions.duration.shorter,
                            }),
                            backgroundImage: ({ functions: { linearGradient }, palette: { gradients } }) =>
                              linearGradient(gradients[color].main, gradients[color].state),

                            "&:not(:last-child)": {
                              mr: 1,
                            },

                            "&:hover, &:focus, &:active": {
                              borderColor: dark.main,
                            },
                          })}
                          onClick={() => setSidenavColor(dispatch, color)}
                        />
                      ))}
                    </SoftBox>
                  </SoftBox>

                  <SoftBox mt={3} lineHeight={1}>
                    <SoftTypography variant="h6">Sidenav Type</SoftTypography>
                    <SoftTypography variant="button" color="text" fontWeight="regular">
                      Choose between 2 different sidenav types.
                    </SoftTypography>

                    <SoftBox
                      sx={{
                        display: "flex",
                        mt: 2,
                      }}
                    >
                      <SoftButton
                        color={transparentSidenav ? "info" : "dark"}
                        variant={transparentSidenav ? "gradient" : "gradient"}
                        onClick={handleTransparentSidenav}
                        disabled={disabled}
                        fullWidth
                        sx={{
                          mr: 1,
                          ...sidenavTypeButtonsStyles,
                        }}
                      >
                        Transparent
                      </SoftButton>
                      <SoftButton
                        color={transparentSidenav ? "dark" : "info"}
                        variant={transparentSidenav ? "gradient" : "gradient"}
                        onClick={handleWhiteSidenav}
                        disabled={disabled}
                        fullWidth
                        sx={sidenavTypeButtonsStyles}
                      >
                        Glass
                      </SoftButton>
                    </SoftBox>
                  </SoftBox>

                </SoftBox>
              </SoftBox>
            </Card> */}
          </SoftBox>
          {/* <Password /> */}
          {/* <Configurator /> */}
        </SoftBox>

        {/* <SoftBox
          position="absolute"
          bottom={-30}
          right={-20}
        >
          <Card
            className="glassmorphism-card"
            style={{
              padding: "10px", cursor: "pointer",
              color: userTheme == 'dark' ? "white" : "black",
              width: 100,
              height: 100,
              borderRadius: '50%',
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",

            }}
            onClick={handleLogout}
          >
            <ExitToAppIcon />  Logout
          </Card>
        </SoftBox> */}
      </SoftBox>
    </DashboardLayout>
  );
}

export default Overview;
